import { render, staticRenderFns } from "./icon-anon.vue?vue&type=template&id=16111842&"
import script from "./icon-anon.vue?vue&type=script&lang=js&"
export * from "./icon-anon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports